module.exports = __webpack_public_path__ + "src/assets/games/1/189.jpg";